















import { Component, Vue, Prop,Emit } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class RowSequence extends Vue {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: number;
  @Prop({default:null}) public displayValue: string;  
  @Prop({default:null}) public item?: Common.ObjectBase;  
  @Prop({ default: null }) public editor: Components.IEditor;  
  @Prop({default:true}) public enabled: boolean;    
  @Prop() public tooltip: string;
  @Prop() public perm: string;
  @Prop() public buttonTooltip: string;

  public showDialog : boolean = false;

  //1～行カウントのリストを取得(ComboBox用)　※現在の行番号は除外
  public count : number;
  public targetSeq: number;
  public getList() : Common.BindItem[] {
      var list = new Array<Common.BindItem>();
      for(let i = 1; i<=this.count; i++){          
          if (i != this.value) list.push(new Common.BindItem(i,i.toString()));
      }
      return list;
  }

  public onClick() {
      var query = new Common.RowSequenceCountQuery(this.item);
      this.$api.execute(query).then(res => {
          this.count = res as number;
          if (this.count == 1){
              this.$api.modal.show("無効な操作","1件しかないため順序変更はできません。",true,null);
          } else {
            this.targetSeq = this.getList()[0].value;
            this.showDialog = true;
          }
      });
  }

  public onExecute() {
      var query = new Common.RowSequenceUpdateQuery(this.item,this.targetSeq);
      this.$api.execute(query).then(res => {
          //エディタのセレクションを更新する
          var updated = res as Common.ObjectBase;
          var listView = (this.editor as Components.Editor).owner;
          listView.onPageChange(listView.params.currentPage);
      });
  }
}

